import axios from 'axios'
import laroute from '~/laroute'
import store from '~/store'

// state
export const state = {
  inventory_transfers: [],
  inventory_transfer: {},
  total: 0,
  locationItemQty: 0
}

// getters
export const getters = {
  inventory_transfers: state => state.inventory_transfers,
  inventory_transfer: state => state.inventory_transfer,
  total: state => state.total,
  locationItemQty: state => state.locationItemQty
}

// mutations
export const mutations = {
  INVENTORY_TRANSFERS (state, data) {
    state.inventory_transfers = data
  },
  ADD_INVENTORY_TRANSFER (state, data) {
    state.inventory_transfer = data
  },
  TOTAL (state, data) {
    state.total = data
  },

  LOCATION_ITEM_QTY (state, data) {
    state.locationItemQty = data
  }

}

// actions
export const actions = {
  async fetchAll ({ commit }, filterData) {
    const { data } = await axios.get(laroute.route('filter_inventory_transfers', {
      companyAbbr: store.getters['auth/company'],
      ...filterData
    }))
    commit('INVENTORY_TRANSFERS', data.items)
    commit('TOTAL', data.total)
  },

  async addInventoryTransfer ({ commit }, data) {
    const response = await axios.post(laroute.route('create_inventory_transfer',
      { companyAbbr: store.getters['auth/company'] }),
    data)
    commit('ADD_INVENTORY_TRANSFER', response.data.inventory_transfer)
  },

  async getLocationData ({ commit }, { itemMasterId, stockLocationId }) {
    const response = await axios.get(laroute.route('get-item-location-qty',
      { itemMasterId, stockLocationId }))
    commit('LOCATION_ITEM_QTY', response.data)
  }

}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/inventoryTransfer.js